
import $ from 'jquery';
import 'flexslider';

const SLIDER_REENABLE_INTERVAL = 6000;

export default class Slider {
  /**
     * Create new slider instance
     *
     * @param {import('../ThemeBase').default} theme
     * @param {HTMLElement} element
     */
  constructor(theme, element) {
    this.theme = theme;
    this.element = element;
    this.$element = $(element);
    this.restartTimer = null;
    this.forcePause = false;

    // Prevent flickering in the flexslider by setting fixed width of the slides
    this.$element.find('.slides li').css('width', this.$element.width());

    this.flexslider = this.configure({});

    // flexslider stops the animation when the page is not focused, this breaks when the section is
    // changed in theme admin because it triggers 'blur' event when another iframe is selected
    $(window).off('blur');

    // Do not focus on any links outside the active slide.
    this.$element.find('.slides li:not(.flex-active-slide) a').attr('tabindex', '-1');

    var dotLinks = $('.slider-pagination-container.slider--' + this.getId()).find('a');

    var self = this;

    dotLinks.each(function () {
      $(this).attr('aria-label', `${self.theme.translations.slide} ${$(this).text()}`)
    })


    this.$allFocusableEls = $('a[href], area[href], input, select, textarea, button, iframe, object, embed, *[tabindex], *[contenteditable]').not('[tabindex=-1], [disabled], :hidden, [aria-hidden="true"]');

    this.playpause = {
      btn_label: self.theme.translations.pause,
      $btn: $('.flex-pauseplay a'),
      is_pressed: "false"
    };

    this.initPlaypause();

    this.playpause.$btn.on('click', function(e) {
      self.setAriaPressed($(e.target));
    });

    this.playpause.$btn.on('keydown', function(e) {
      e.preventDefault();
      self.playpauseHandleKeydown(e);
    })

    this.$element
  }

    initPlaypause = () => {
      this.playpause.btn_index = this.$allFocusableEls.index(this.playpause.$btn);
      this.playpause.$nextFocusableEl = this.$allFocusableEls[this.playpause.btn_index + 1];
      this.playpause.$prevFocusableEl = this.$allFocusableEls[this.playpause.btn_index - 1];

      this.playpause.$btn.attr('role', 'button');
      this.playpause.$btn.attr('aria-label', this.playpause.btn_label);
      this.playpause.$btn.attr('aria-pressed', this.playpause.is_pressed);
    }

    playpauseHandleKeydown = (e) => {
      var isTabKey = e.keyCode == 9 ? true : false;
      var isEnterKey = e.keyCode == 13 ? true : false;

      if (isTabKey) {
        if (e.shiftKey) {
          this.playpause.$prevFocusableEl.focus();
        } else {
          this.playpause.$nextFocusableEl.focus();
        }
      } else if (isEnterKey) {
        $(e.target).trigger('click');
      } else {
        return;
      }
    }

    setAriaPressed = (target) => {
      this.playpause.is_pressed = target.hasClass('flex-pause') ? 'false' : 'true';
      // target.attr('aria-label', this.playpause.is_pressed);
      target.attr('aria-pressed', this.playpause.is_pressed);
    }

    getSpeed = () => {
      return parseInt(this.$element.data('sliderSlideTime'));
    };

    getId = () => {
      return this.$element.data('sliderId');
    };

    getSmoothHeightState = () => {
      return $(window).width() < 767;
    };

    getAnimation = () => {
      return this.$element.data('sliderAnimation');
    };

    getDots = () => {
      return this.$element.data('sliderDots');
    };

    getArrows = () => {
      return this.$element.data('sliderArrows');
    };

    getControls = () => {
      return this.$element.data('sliderControls');
    };

    currentSlide = () => {
      return this.$element.find('.flex-active-slide').data('slide-index');
    }

    showSlide = (index) => {
      if (this.getSpeed() > 0) {
        this.flexslider.pause();
        this.forcePause = true;
      }
      if (this.currentSlide() !== index) {
        // Change slide without animation
        this.flexslider.flexAnimate(index);
        //this.flexslider.wrapup($(window).width());
      }
    };

    startAnimation = () => {
      // Don't start animation when autorotate is disabled
      this.forcePause = false;
      if (this.getSpeed() > 0) {
        this.flexslider.play();
      }
    };

    onSlideChange = (slider) => {
      var speed = this.getSpeed();
      this.$element.find('.slides li a').attr('tabindex', '0');
      this.$element.find('.slides li:not(.flex-active-slide) a').attr('tabindex', '-1');
      if (!this.forcePause && !slider.playing && speed > 0) {
        // restart autoscroll after given interval since last interaction
        clearTimeout(this.restartTimer);
        this.restartTimer = setTimeout(function () {
          slider.play();
        }, Math.max(0, SLIDER_REENABLE_INTERVAL - speed));
      }
    };

    configure = (options) => {
      if ($(window).width() === 0) {
        // the app is not yet loaded in the admin, retry later
        setTimeout(this.configure.bind(this), 200);
        return;
      }
      var speed = this.getSpeed();
      var id = this.getId();

      var numSlides = this.$element.find('ul.slides li').length;

      var opts = $.extend(
        {
          pausePlay: (numSlides > 1 && this.getControls()),
          pauseText: "",
          playText: "",
          directionNav: numSlides > 1 ? this.getArrows() : "",
          controlNav: numSlides > 1 ? this.getDots() : "",
          startAt: 0,
          slideshowSpeed: speed,
          animation: this.getAnimation(),
          controlsContainer: $('.slider-pagination-container.slider--'+id),
          customDirectionNav: $('.flex-direction-nav.slider--'+id+' button'),
          slideshow: (speed > 0 && numSlides > 1),
          touch: numSlides > 1,
          pauseOnAction: true,
          after: this.onSlideChange.bind(this)
        },
        options,
      );

      if ($('.slider-pagination-container.slider--'+id).length === 0){
        options.controlNav = false;
      } else {
        options.controlNav = true;
      }

      if($('.flex-direction-nav.slider--'+id+' a').length === 0){
        options.directionNav = false;
      } else {
        options.directionNav = true;
      }

      this.$element.find('ul.slides').width('auto');
      return this.$element.flexslider(opts).data('flexslider');
    };
}
